module.exports = __webpack_public_path__ + "img/volume-off.473acce1.svg";